import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { currency } from "../../../../../common/services/common.service";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectOrdersQueryItems } from "../../../../../redux/orders/selector";
import { orders } from "../../../../../redux/orders/action";
import moment from "moment";
import PageLoader from "../../../../../components/PageLoader";
import useWindowDimensions from "../../../../../hooks/useWindowsDimensions";

export const OrderTracking = () => {
    const { state } = useLocation();
    const { orderId } = state
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { height, width } = useWindowDimensions();
    const orderDetails = useSelector(selectOrdersQueryItems);
    const [order, getOrder] = useState<any>();

    useEffect(() => {
        if (orderId) {
            dispatch(orders.query({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/query-by-tracking-number`, entity: 'orders', jsonData:
                {
                    Records: [
                        {
                            context: {

                            },
                            Message: {
                                TrackingNumber: orderId
                            }
                        }
                    ]
                }
            }))
        }

    }, []);

    useEffect(() => {
        console.log('orderDetails', orderDetails)
        getOrder(orderDetails?.result?.items)
    }, [orderDetails]);

    const convertDate = (date: string) => {
        var gmtDateTime = moment.utc(date, "YYYY-MM-DD HH:mm")
        return gmtDateTime.local().format('YYYY-MMM-DD h:mm A');
    }
    const orderStatus = (id: number) => {
        switch (id) {
            case 10:
                return 'Shipping Not Required';
            case 12:
                return 'Pending';
            case 13:
                return 'Created';
            case 14:
                return 'Serviceable';
            case 16:
                return 'NonServiceable';
            case 17:
                return 'Searching For Agent';
            case 18:
                return 'Packed';
            case 19:
                return 'Agent Assigned';
            case 20:
                return 'Ready To Ship';
            case 22:
                return 'Shipping In Progress';
            case 24:
                return 'At Pickup Location';
            case 30:
                return 'Order PickedUp';
            case 40:
                return 'In Transit';
            case 45:
                return 'At DropLocation';
            case 50:
                return 'Out For Delivery';
            case 60:
                return 'Order Delivered';
            case 70:
                return 'RTO Initiated';
            case 75:
                return 'Partially Returned';
            case 77:
                return 'Liquidated';
            case 79:
                return 'RTO Disposed';
            case 80:
                return 'RTO Delivered';
            case -10:
                return 'Cancelled'
        }
    }

    const paymentMode = (id: any) => {
        switch (id) {
            case 10:
                return 'Cash';
            case 20:
                return 'Online'
            default:
                return 'Cash'
        }

    }

    console.log(order, 'order')


    return (
        <>
            {width && width < 720 ?
                //  Start - Mobile View  
                <section className="max-h-screen w-screen my-16 py-5">
                    <div className="w-full p-5 pb-20">
                        <div className="flex flex-row justify-between items-center w-full">
                            <div className="text-xl font-semibold text-gray-900">
                                Track the delivery of order:
                            </div>
                            <div className="text-lg font-semibold text-blue-800">
                                {orderId}
                            </div>
                        </div>
                        <div className="flex flex-col justify-between items-center w-full py-4">
                            <div className="px-2 w-full bg-white overflow-hidden rounded-lg border border-gray-200 dark:divide-gray-700">
                                {order && _.map(order?.Message?.ShipmentItems, (item: any) => (
                                    <div className="flex flex-row justify-center items-center py-2 pb-4 space-x-3 border-b border-gray-200 w-full">

                                        <div className="flex flex-col justify-start items-center w-2/3 space-y-2">
                                            <div className="text-left font-semibold text-base text-black w-full">
                                                {item.ItemName}
                                            </div>
                                            <div className="flex flex-row justify-between items-center w-full">
                                                <div className="font-medium text-sm text-black">
                                                    Qty:
                                                </div>
                                                <div className="font-medium text-sm text-indigo-600 mr-2">
                                                    {item.Quantity}
                                                </div>
                                            </div>
                                            <div className="flex flex-row justify-between items-center w-full">
                                                <div className="font-medium text-sm text-black">
                                                    Price:
                                                </div>
                                                <div className="font-medium text-sm text-indigo-600 mr-2">
                                                    {currency(item.UnitPriceInclTax)}
                                                </div>
                                            </div>
                                            <div className="flex flex-row justify-between items-center w-full">
                                                <div className="font-medium text-sm text-black">
                                                    Status:
                                                </div>
                                                <div className="font-medium text-sm mr-2">
                                                    {orderStatus(order?.Message?.ShippingStatusId)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3 pt-2'>

                                    <div className="bg-stone-50 mb-4 p-4 border rounded">
                                        <div className="text-xl border-b text-cyan-600 font-bold">
                                            From Address
                                        </div>
                                        <h1>
                                            Name:  {order?.Message?.fulfillments[0]?.start?.location?.address?.Name}
                                            ,
                                        </h1>
                                        <h1 className='pt-2'>{order?.Message?.fulfillments[0]?.start?.location?.address?.Locality}
                                            ,</h1>

                                        <h1>  {order?.Message?.fulfillments[0]?.start?.location?.address?.City}

                                            {' '}

                                            -
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.AreaCode}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.State}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.Country}
                                            ,
                                        </h1>
                                        <h1>
                                            Email:  {order?.Message?.fulfillments[0]?.start?.contact?.email}
                                            ,
                                        </h1>
                                        <h1>
                                            Ph:  {order?.Message?.fulfillments[0]?.start?.contact?.phone}
                                            .

                                        </h1>
                                    </div>
                                    <div className="bg-stone-50 mb-4 p-4 border rounded">
                                        <div className="text-xl border-b text-cyan-600 font-bold">
                                            To Address
                                        </div>
                                        <h1>
                                            Name:  {order?.Message?.fulfillments[0]?.end?.location?.address?.Name}
                                            ,
                                        </h1>
                                        <h1 className='pt-2'>{order?.Message?.fulfillments[0]?.end?.location?.address?.Locality}
                                            ,</h1>

                                        <h1>  {order?.Message?.fulfillments[0]?.end?.location?.address?.City}

                                            {' '}

                                            -
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.AreaCode}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.State}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.Country}
                                            ,
                                        </h1>
                                        <h1>
                                            Email:  {order?.Message?.fulfillments[0]?.end?.contact?.email}
                                            ,
                                        </h1>
                                        <h1>
                                            Ph:  {order?.Message?.fulfillments[0]?.end?.contact?.phone}
                                            .

                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div className="mx-2 my-4 w-full bg-white overflow-hidden rounded-lg border border-gray-200 dark:divide-gray-700">
                                <div className="p-3 py-4 w-full flex-col flex justify-between">
                                    <div className="text-xl font-semibold text-gray-900">
                                        Order history
                                    </div>
                                    <div className="py-4 w-full">
                                        <ol className="relative ms-3 border-s border-gray-200">
                                            <li className="mb-10 ms-6">
                                                <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                                                    <svg className="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5" />
                                                    </svg>
                                                </span>
                                                {/* <h4 className="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">Estimated delivery in 24 Nov 2023</h4> */}
                                                <p className="text-sm font-normal text-gray-500 dark:text-gray-400">Delivered</p>
                                            </li>
                                            <li className="mb-10 ms-6">
                                                <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                                                    <svg className="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
                                                    </svg>
                                                </span>
                                                {/* <h4 className="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">Today</h4> */}
                                                <p className="text-sm font-normal text-gray-500 dark:text-gray-400">Delivery in progress</p>
                                            </li>

                                            <li className="mb-10 ms-6 text-primary-700 dark:text-primary-500">
                                                <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                                                    <svg className="h-4 w-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4h16v16H4V4z" />
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16" />
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 4v4" />
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 4v4" />
                                                    </svg>
                                                </span>
                                                <h4 className="mb-0.5 font-semibold">{convertDate(order?.Message?.ShippedDateUtc)}</h4>
                                                <p className="text-sm">Packing In-Progress</p>
                                            </li>
                                            <li className="ms-6 text-primary-700 dark:text-primary-500">
                                                <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                                                    <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                                    </svg>
                                                </span>
                                                <div>
                                                    <h4 className="mb-0.5 font-semibold">{convertDate(order?.Message?.ShippedDateUtc)}</h4>
                                                    <a href="#" className="text-sm font-medium hover:underline">Order placed</a>
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                //  End - Mobile View  
                :
                <section className="bg-gray-50 py-8 antialiased md:py-16">
                    <div className="mx-auto max-w-screen-xl px-4 2xl:px-0">
                        <h2 className="text-xl font-semibold text-gray-900 sm:text-2xl">Track the delivery of order: {orderId}</h2>

                        <div className="mt-6 sm:mt-8 lg:flex lg:gap-8">
                            <div className="w-full bg-white divide-y divide-gray-200 overflow-hidden rounded-lg border border-gray-200 dark:divide-gray-700 lg:max-w-xl xl:max-w-2xl p-4">

                                {order && _.map(order?.Message?.ShipmentItems, (item: any) => (
                                    <div className="flex flex-col lg:flex-row items-center py-6 border-b border-gray-200 gap-6 w-full">

                                        <div className="flex flex-row items-center w-full ">
                                            <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
                                                <div className="flex items-center">
                                                    <div className="">
                                                        <h2 className="font-semibold text-xl leading-8 text-black mb-3">
                                                            {item.ItemName}</h2>

                                                        <div className="flex items-center ">

                                                            <p className="font-medium text-base leading-7 text-black ">Qty: <span
                                                                className="text-gray-500">{item.Quantity}</span></p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="grid grid-cols-5">
                                                    <div className="col-span-5 lg:col-span-1 flex items-center max-lg:mt-3">
                                                        <div className="flex gap-3 lg:block">
                                                            <p className="font-medium text-sm leading-7 text-black">price</p>
                                                            <p className="lg:mt-4 font-medium text-sm leading-7 text-indigo-600">{currency(item.UnitPriceInclTax)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3 ">
                                                        <div className="flex gap-3 lg:block">
                                                            <p className="font-medium text-sm leading-7 text-black">Status
                                                            </p>
                                                            <p
                                                                className="font-medium text-sm leading-6 whitespace-nowrap py-0.5 px-3 rounded-full lg:mt-3 bg-emerald-50 text-emerald-600">
                                                                {orderStatus(order?.Message?.ShippingStatusId)}</p>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                ))}
                                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3 pt-2'>

                                    <div className="bg-stone-50 mb-4 p-4 border rounded">
                                        <div className="text-xl border-b text-cyan-600 font-bold">
                                            From Address
                                        </div>
                                        <h1>
                                            Name:  {order?.Message?.fulfillments[0]?.start?.location?.address?.Name}
                                            ,
                                        </h1>
                                        <h1 className='pt-2'>{order?.Message?.fulfillments[0]?.start?.location?.address?.Locality}
                                            ,</h1>

                                        <h1>  {order?.Message?.fulfillments[0]?.start?.location?.address?.City}

                                            {' '}

                                            -
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.AreaCode}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.State}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.start?.location?.address?.Country}
                                            ,
                                        </h1>
                                        <h1>
                                            Email:  {order?.Message?.fulfillments[0]?.start?.contact?.email}
                                            ,
                                        </h1>
                                        <h1>
                                            Ph:  {order?.Message?.fulfillments[0]?.start?.contact?.phone}
                                            .

                                        </h1>
                                    </div>
                                    <div className="bg-stone-50 mb-4 p-4 border rounded">
                                        <div className="text-xl border-b text-cyan-600 font-bold">
                                            To Address
                                        </div>
                                        <h1>
                                            Name:  {order?.Message?.fulfillments[0]?.end?.location?.address?.Name}
                                            ,
                                        </h1>
                                        <h1 className='pt-2'>{order?.Message?.fulfillments[0]?.end?.location?.address?.Locality}
                                            ,</h1>

                                        <h1>  {order?.Message?.fulfillments[0]?.end?.location?.address?.City}

                                            {' '}

                                            -
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.AreaCode}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.State}
                                            ,
                                        </h1>
                                        <h1>
                                            {order?.Message?.fulfillments[0]?.end?.location?.address?.Country}
                                            ,
                                        </h1>
                                        <h1>
                                            Email:  {order?.Message?.fulfillments[0]?.end?.contact?.email}
                                            ,
                                        </h1>
                                        <h1>
                                            Ph:  {order?.Message?.fulfillments[0]?.end?.contact?.phone}
                                            .

                                        </h1>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-6 grow sm:mt-8 lg:mt-0">
                                <div className="space-y-6 rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
                                    <h3 className="text-xl font-semibold text-gray-900">Order history</h3>

                                    <ol className="relative ms-3 border-s border-gray-200">
                                        <li className="mb-10 ms-6">
                                            <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                                                <svg className="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m4 12 8-8 8 8M6 10.5V19a1 1 0 0 0 1 1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 0 1-1v-8.5" />
                                                </svg>
                                            </span>
                                            {/* <h4 className="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">Estimated delivery in 24 Nov 2023</h4> */}
                                            <p className="text-sm font-normal text-gray-500 dark:text-gray-400">Delivered</p>
                                        </li>

                                        <li className="mb-10 ms-6">
                                            <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white dark:bg-gray-700 dark:ring-gray-800">
                                                <svg className="h-4 w-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h6l2 4m-8-4v8m0-8V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9h2m8 0H9m4 0h2m4 0h2v-4m0 0h-5m3.5 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-10 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
                                                </svg>
                                            </span>
                                            {/* <h4 className="mb-0.5 text-base font-semibold text-gray-900 dark:text-white">Today</h4> */}
                                            <p className="text-sm font-normal text-gray-500 dark:text-gray-400">Delivery in progress</p>
                                        </li>



                                        <li className="mb-10 ms-6 text-primary-700 dark:text-primary-500">
                                            <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                                                <svg className="h-4 w-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">

                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4h16v16H4V4z" />
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16" />
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 4v4" />
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 4v4" />
                                                </svg>


                                            </span>
                                            <h4 className="mb-0.5 font-semibold">{convertDate(order?.Message?.ShippedDateUtc)}</h4>
                                            <p className="text-sm">Packing In-Progress</p>
                                        </li>

                                        <li className="ms-6 text-primary-700 dark:text-primary-500">
                                            <span className="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-primary-100 ring-8 ring-white dark:bg-primary-900 dark:ring-gray-800">
                                                <svg className="h-4 w-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 11.917 9.724 16.5 19 7.5" />
                                                </svg>
                                            </span>
                                            <div>
                                                <h4 className="mb-0.5 font-semibold">{convertDate(order?.Message?.ShippedDateUtc)}</h4>
                                                <a href="#" className="text-sm font-medium hover:underline">Order placed</a>
                                            </div>
                                        </li>
                                    </ol>


                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end">
                            <div>
                                <button
                                    onClick={() => navigate('/customer/order/track')}
                                    className="m-4 bg-gray-800 text-white hover:bg-[bg-skin-primary] font-semibold p-2 h-16 w-40"
                                >
                                    Back
                                </button>

                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    )

}